export default __webpack_public_path__ + "static/media/CompareCarBanner.a476cd11.png";